module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/homeSale.svg?28e8dfca48c6ca74d9d872ad3a768ee8";